export default __webpack_public_path__ + "static/media/location-drop-pin.inline.7004557d.svg";